import {useController, useFormContext} from "react-hook-form";
import Select from "react-select";


export default function Datalist({name, label, options, customProps, colorBox = false}) {
    const {control, formState: {errors}} = useFormContext()
    const {field} = useController({
        control,
        name,
    })
    const error = errors[name]



    return (
        <div className="mb-2">
            <label htmlFor={name} className="form-label">{label}</label>

            <Select
                ref={field.ref}
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                options={options}
                formatOptionLabel={o => (
                    <div className="selectOption">
                        {!!o.img && (
                            <div className="selectOption__img">
                                <img src={o.img} alt=""/>
                            </div>
                        )}
                        {!!o.color && (
                            <div
                                className="selectOption__colorBox"
                                style={{backgroundColor: o.color}}
                            />
                        )}
                        <div className="selectOption__label">{o.label}</div>
                    </div>
                )}
            />
            {!!error && (
                <div className="invalid-feedback">{error.message}</div>
            )}
        </div>
    )
}
